import React                 from 'react';
import { arrayX as tooltip } from 'pu-data/Tooltips';
import TextComponent         from './TextComponent';

const ArrayX = (props) => {
  const name = 'array_x';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="Array Overall Length (inches)"
      name={name}
      value={props.parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};

ArrayX.defaultProps = {};

export default ArrayX;
